module.exports = __webpack_public_path__ + "static/img/1809105.3438e5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/180910/1809105.jpg
// module id = 94ui
// module chunks = 0